export default (data) => {
    if (data >= 10000) {
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return data.toString();
}
